export const machineMigrationOpportunityPath = (appSlug: string) => `/apps/${appSlug}/machine_migration_opportunity`;
